export class ListData {
  canAdd!: boolean;
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  pageData!: PageData[];
}
export class PageData {
  canDelete!: boolean
  canEdit!: boolean
  created!: string
  id!: string
  name!: string
  title_EN!: string
  title_AR!: string
  numberOfUse!: number
  icon!: any
  categoryId!: number
  categoryName!: string
  updated!: string
  isSelected!: boolean
  canSelect!: boolean
}

// for Units too
export class Record {
  id!: string
  name!: string
  title_EN!: string
  title_AR!: string
  icon!: any
  categoryId!: number
  categoryName!: string
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  ingredientName!: string;
  categoryId!: number;
  restaurantId!: number;
  sortItems!: number
  searchText!: string;
}

export class IngredientFilter {
  ingredientName!: string;
  categoryId!: number;
  restaurantId!: number;
  categoryIds!: number[];

}

export enum sortList {
  Name = 0,
  NewestCreate = 1,
  OldestCreate = 2,
  HighestUse = 3,
  LowestUse = 4
}


export class IngredientObject {
  restaueantName!: string
  restaurantIngredientDtos!: IngredientList[]
}
export class IngFilter {
  pageNumber!: number;
  pageSize!: number;
  searchText!: string;
  categoryId!: number;
  restaurantId!: number;
}

// Ingredient List for Restaurant
export class IngredientList {
  ingredient!: IngredientListItem;
  canEditIngredient!: boolean;
  canDeleteIngredient!: boolean;
  id!: number;
  ingredientId!: number;
  ingredientUnit!: IngredientUnit;

  name!: string;
  icon!: string;
  unit!: string;
  ingredientUnitId!: number;
  stockQuantityNumber!: any;
  menuQuantityNumber!: any;
  unitCost!: any;
}

export class IngredientListItem {
  canDelete!: boolean;
  canEdit!: boolean;
  created!: string;
  id!: string;
  name!: string;
  title_EN!: string;
  title_AR!: string;
  numberOfUse!: number;
  icon: any;
  categoryId!: number;
  categoryName!: string;
  updated!: string;
}

export class IngredientUnit {
  id!: number
  name!: string;
  title_AR!: string;
  title_EN!: string;
}

export class Ingredient {
  restaurantId!: number;
  ingredients!: {
    ingredientId: number;
    ingredientUnitId: number;
  }[]
}
